import { ResponseError, ResponseResultType } from '../../../config/api';
import { useSWR, responseInterface } from '../../../config/overrides/swr';
import API, { PROTECTED, EVENT, MEETING, PrivateMeetingDetailsResponseType } from '../../../lib/api';
import { IAuthContext, useAuth } from '../../../lib/context-providers/auth-context';
import { composeUrl } from '../../../lib/api/utils';
import { useRef } from 'react';
import { getAccessToken } from '../../../lib/auth';

const { fetchMeetingPrivateDetails } = API[PROTECTED];

const fetchMeetingPrivateDetailsWrapper = async (url: string): Promise<ResponseResultType<PrivateMeetingDetailsResponseType>> => {
  const [path, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  params.delete('ts');
  const qs = params.toString();
  return fetchMeetingPrivateDetails(qs ? `${path}?${qs}` : path);
};

export function useMeetingPrivateDetails(
  eventId: string,
  meetingId: string,
  joinMethodId?: string | null,
): responseInterface<PrivateMeetingDetailsResponseType, ResponseError> {
  const auth = useAuth() as IAuthContext;
  const timestamp = useRef(`ts=${Date.now()}`);
  const hasAccessToken = (): boolean => {
    try {
      return !!getAccessToken();
    } catch {
      return false;
    }
  };

  const shouldSendRequest = [eventId, meetingId].every(Boolean) && (Boolean(auth.isAuthenticated) || hasAccessToken());
  const joinMethodQuery = joinMethodId ? `joinMethodId=${encodeURIComponent(joinMethodId)}&` : '';
  const key = shouldSendRequest
    ? `${composeUrl(...[ EVENT, eventId, MEETING, meetingId ])}?${joinMethodQuery}${timestamp.current}`
    : null;

  return useSWR(key, fetchMeetingPrivateDetailsWrapper);
}
